import React, { useState, useEffect } from "react"

import { FormContextProvider } from "../../contexts/formContext"
import { FormInputState } from "../../utils/validations"
import LoginSignupForm from "./LoginSignupForm"

interface Props {
  showHeader?: boolean
  startLoginMode?: boolean
  redirectUrl?: string
  confirmationPage?: string
  confirmationSuccessPage?: string
  email?: string
  freshdesk?: boolean
  noRedirect?: boolean
  loginMode?: boolean
  setLoginMode?: (x: boolean) => void
  alreadyHaveAccountTxt?: string
}
const Login = ({
  showHeader = true,
  startLoginMode = true,
  redirectUrl = "/user",
  noRedirect = false,
  confirmationPage = "email-confirmation",
  confirmationSuccessPage = "email-confirmed",
  email = "",
  freshdesk = false,
  alreadyHaveAccountTxt = "",
  setLoginMode,
  loginMode,
}: Props) => {
  const intialFormInput: Record<string, FormInputState> = {
    firstName: {
      value: "",
      label: "First Name",
      validation: [
        { type: "required" },
        { type: "min", value: 2 },
        { type: "max", value: 150 },
      ],
    },
    lastName: {
      value: "",
      label: "Last Name",
      validation: [
        { type: "required" },
        { type: "min", value: 2 },
        { type: "max", value: 150 },
      ],
    },
    email: {
      value: "",
      label: "Email",
      validation: [
        { type: "required" },
        { type: "email" },
        { type: "min", value: 3 },
        { type: "max", value: 150 },
      ],
    },
    password: {
      value: "",
      label: "Password",
      validation: [
        { type: "required" },
        { type: "min", value: 5 },
        { type: "max", value: 150 },
      ],
    },
    passwordConfirm: {
      value: "",
      label: "Confirm Password",
      validation: [
        { type: "required" },
        { type: "min", value: 5 },
        { type: "max", value: 150 },
        { type: "match", value: "password" },
      ],
    },
    allowMarketing: {
      value: true,
      type: "checkbox",
      label: "Newsletter",
    },
  }

  if (!setLoginMode) {
    const [isLoginMode, setIsLoginMode] = useState(startLoginMode)
    setLoginMode = setIsLoginMode
    loginMode = isLoginMode
  }

  const [cleanUp, setCleanUp] = useState(false)

  useEffect(() => {
    setCleanUp(false)
    return () => {
      setCleanUp(true)
    }
  }, [])
  return (
    <>
      {!cleanUp && (
        <FormContextProvider initialInputs={intialFormInput}>
          <LoginSignupForm
            startLoginMode={startLoginMode}
            redirectUrl={redirectUrl}
            showHeader={showHeader}
            noRedirect={noRedirect}
            confirmationPage={confirmationPage}
            confirmationSuccessPage={confirmationSuccessPage}
            email={email}
            freshdesk={freshdesk}
            alreadyHaveAccountTxt={alreadyHaveAccountTxt}
            loginMode={loginMode}
            setLoginMode={setLoginMode}
          />
        </FormContextProvider>
      )}
    </>
  )
}

export default Login
